// Progreso de un grupo de ítems del checklist. Solo cuenta ítems VISIBLES.
// `faltan` = visibles sin estado (el único disparador de alerta/rojo).
// `conProblema` = visibles marcados "Con problema" (RECHAZADO); es información,
// no alerta — se muestra en azul, no cuenta para el rojo del anillo.
export function computeItemGroupProgress(actividades, estados) {
  const visibles = (actividades || []).filter((a) => a?.Respuesta?.visible);
  let done = 0;
  let faltan = 0;
  let conProblema = 0;
  for (const a of visibles) {
    const id = a.Respuesta.id;
    const eff = estados?.[id] !== undefined ? estados[id] : a.Respuesta.estado;
    if (eff) done += 1;
    else faltan += 1;
    if (eff === 'RECHAZADO') conProblema += 1;
  }
  return { done, total: visibles.length, faltan, conProblema };
}
